import React from "react";
import { graphql } from "gatsby";
import { Header } from "../components/Header";

const DocLayout = ({ data, location }) => {
  const { html, frontmatter } = data.markdownRemark;
  return (
    <div className="flex flex-col h-full max-w-8xl mx-auto overflow-hidden">
      <Header />
      <div className="flex h-full">
        {/* <!-- Sidebar --> */}
        <div className="hidden md:flex h-full py-4 px-16 border-r border-gray-200">
          sidebar
        </div>
        {/* <!-- content --> */}
        <div className="px-4 sm:px-6 py-4 flex flex-col overflow-y-auto">
          <span className="font-semibold text-2xl mb-4">
            {frontmatter.title}
          </span>
          {html}
        </div>
      </div>
    </div>
  );
};

export default DocLayout;

export const pageQuery = graphql`
  query TemplateDocsMarkdown($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
      fields {
        slug
      }
    }
  }
`;
